import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';
import { ClienteAnaliseFinanceiraStatusPipeModule } from '../pipes';

import { ClienteAnaliseFinanceiraStatusBadgeComponent } from './cliente-analise-financeira-status-badge.component';


@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseFinanceiraStatusPipeModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraStatusBadgeComponent
    ],
    exports: [
        ClienteAnaliseFinanceiraStatusBadgeComponent
    ]
})
export class ClienteAnaliseFinanceiraStatusBadgeModule { }
